import React from "react";
import { Tooltip, Typography } from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import { isLikelyUuid } from "../Orders/utils/orderUtils";

type TypographyProps = React.ComponentProps<typeof Typography>;

/**
 * Renders a short human-readable code as-is; for UUID-like values shows a
 * friendly label with full id in a tooltip (detail pages should prefer entity links).
 */
const OpaqueIdOrText: React.FC<{
  value: string | null | undefined;
  variant?: TypographyProps["variant"];
  fontWeight?: TypographyProps["fontWeight"];
}> = ({ value, variant = "body2", fontWeight = "medium" }) => {
  const { t } = useKivunovaTranslation();

  if (value == null || value === "") {
    return (
      <Typography variant={variant} fontWeight={fontWeight}>
        {t("not-available", "N/A")}
      </Typography>
    );
  }

  if (isLikelyUuid(value)) {
    return (
      <Tooltip title={value}>
        <Typography
          component="span"
          variant={variant}
          fontWeight={fontWeight}
          sx={{ cursor: "help" }}
        >
          {t("internal-reference-on-file", "On file")}
        </Typography>
      </Tooltip>
    );
  }

  return (
    <Typography variant={variant} fontWeight={fontWeight}>
      {value}
    </Typography>
  );
};

export default OpaqueIdOrText;
